import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductEditComponent } from './product-edit/product-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { PipesModule } from '../../pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule,
    FormsModule,
    PipesModule,
    TranslateModule,
    SharedModule
  ],
  declarations: [ProductListComponent, ProductEditComponent]
})
export class ProductsModule {}



// WEBPACK FOOTER //
// ./src/app/modules/products/products.module.ts